<template>
  <user-agreement :user-agreement-type="userAgreementType"></user-agreement>
</template>

<script>
import UserAgreement from '@/components/User/UserAgreement.vue';
export default {
  name: "RewardRuleMiniApp",
  data () {
    return {
      userAgreementType: 3
    }
  },
  components: {
    UserAgreement
  },
  beforeMount () {

  },
  methods: {
  }
}
</script>

<style lang="less">
</style>